import styled from "styled-components";

export const FooterContainer = styled.section`
    min-height: 15vh;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 5px #c9d6cd;
`
export const FooterText = styled.p`
    font-size: 1rem;
    color: black;
`